import * as React from "react"

function ContentComparison(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 584.409 307.557"
      {...props}
    >
      <defs>
        <style>
          {
            ".content-comparison_cls-1{fill:#efc621}.content-comparison_cls-3{fill:#00aeef}.content-comparison_cls-4{fill:#e9ecef}.content-comparison_cls-5{fill:#c1c6cb}"
          }
        </style>
      </defs>
      <g id="content-comparison_Guides_and_Back" data-name="Guides and Back">
        <path
          className="content-comparison_cls-1"
          d="M577.267 240.614c-21.67 34.51-58.889 50.735-204.6 72.326-141.667 20.992-213.441 30.989-259.33 6.515C101 312.876 17.013 268.084 12.342 181.32c-3.482-64.67 38.4-128.451 91.836-149.066 56.034-21.618 85.575 19.357 209.2 53.935C473.938 131.1 567.4 102.057 591.6 157.211c15.649 35.657-10.479 77.266-14.333 83.403z"
          transform="translate(-12.139 -26.236)"
        />
        <path fill="#fff" d="M37.861 23.764h500v250h-500z" />
      </g>
      <g id="content-comparison_Page_Content" data-name="Page Content">
        <rect
          className="content-comparison_cls-3"
          x={452.776}
          y={126.821}
          width={53.085}
          height={23.545}
          rx={4}
        />
        <rect
          className="content-comparison_cls-1"
          x={69.861}
          y={126.821}
          width={53.085}
          height={23.545}
          rx={4}
        />
        <rect
          className="content-comparison_cls-4"
          x={70.361}
          y={61.471}
          width={206.261}
          height={53.632}
          rx={3.5}
        />
        <path
          className="content-comparison_cls-4"
          d="M285.26 88.207a3 3 0 013 3v46.632a3 3 0 01-3 3H86a3 3 0 01-3-3V91.207a3 3 0 013-3h199.26m0-1H86a4.012 4.012 0 00-4 4v46.632a4.012 4.012 0 004 4h199.26a4.012 4.012 0 004-4V91.207a4.012 4.012 0 00-4-4z"
          transform="translate(-12.139 -26.236)"
        />
        <path
          className="content-comparison_cls-5"
          d="M69.861 41.764h135.505v7.989H69.861zM75.892 68.968H257.4v7.989H75.892z"
        />
        <path
          className="content-comparison_cls-1"
          d="M102.112 68.968h24.308v7.989h-24.308z"
        />
        <path
          className="content-comparison_cls-5"
          d="M75.892 84.277h163.749v7.989H75.892zM75.892 99.587h64.245v7.989H75.892z"
        />
        <path
          className="content-comparison_cls-1"
          d="M178.984 84.292h60.657v7.989h-60.657z"
        />
        <rect
          className="content-comparison_cls-4"
          x={299.1}
          y={61.471}
          width={206.261}
          height={53.632}
          rx={3.5}
        />
        <path
          className="content-comparison_cls-4"
          d="M514 88.207a3 3 0 013 3v46.632a3 3 0 01-3 3H314.74a3 3 0 01-3-3V91.207a3 3 0 013-3H514m0-1H314.74a4.012 4.012 0 00-4 4v46.632a4.012 4.012 0 004 4H514a4.012 4.012 0 004-4V91.207a4.012 4.012 0 00-4-4z"
          transform="translate(-12.139 -26.236)"
        />
        <path
          className="content-comparison_cls-5"
          d="M298.6 41.764h135.505v7.989H298.6zM304.631 68.968h181.508v7.989H304.631z"
        />
        <path
          className="content-comparison_cls-3"
          d="M330.851 68.968h24.308v7.989h-24.308z"
        />
        <path
          className="content-comparison_cls-5"
          d="M304.631 84.277H468.38v7.989H304.631zM304.631 99.587h64.245v7.989h-64.245z"
        />
        <path
          className="content-comparison_cls-3"
          d="M407.723 84.292h60.657v7.989h-60.657z"
        />
        <rect
          className="content-comparison_cls-3"
          x={452.776}
          y={232.219}
          width={53.085}
          height={23.545}
          rx={4}
        />
        <rect
          className="content-comparison_cls-1"
          x={69.861}
          y={231.553}
          width={53.085}
          height={24.211}
          rx={4}
        />
        <rect
          className="content-comparison_cls-4"
          x={70.361}
          y={181.29}
          width={206.261}
          height={39.211}
          rx={3.5}
        />
        <path
          className="content-comparison_cls-4"
          d="M285.26 208.026a3 3 0 013 3v32.211a3 3 0 01-3 3H86a3 3 0 01-3-3v-32.211a3 3 0 013-3h199.26m0-1H86a4.012 4.012 0 00-4 4v32.211a4.012 4.012 0 004 4h199.26a4.012 4.012 0 004-4v-32.211a4.012 4.012 0 00-4-4z"
          transform="translate(-12.139 -26.236)"
        />
        <path
          className="content-comparison_cls-5"
          d="M69.861 161.583h135.505v7.989H69.861zM75.892 188.787H257.4v7.989H75.892zM75.892 204.096h136.872v7.989H75.892z"
        />
        <path
          className="content-comparison_cls-1"
          d="M116.178 204.112h60.657v7.989h-60.657z"
        />
        <rect
          className="content-comparison_cls-4"
          x={299.1}
          y={181.29}
          width={206.261}
          height={39.211}
          rx={3.5}
        />
        <path
          className="content-comparison_cls-4"
          d="M514 208.026a3 3 0 013 3v32.211a3 3 0 01-3 3H314.74a3 3 0 01-3-3v-32.211a3 3 0 013-3H514m0-1H314.74a4.012 4.012 0 00-4 4v32.211a4.012 4.012 0 004 4H514a4.012 4.012 0 004-4v-32.211a4.012 4.012 0 00-4-4z"
          transform="translate(-12.139 -26.236)"
        />
        <path
          className="content-comparison_cls-5"
          d="M298.6 161.583h135.505v7.989H298.6zM304.631 188.787h181.508v7.989H304.631zM304.631 204.096H468.38v7.989H304.631z"
        />
        <path
          className="content-comparison_cls-3"
          d="M338.548 204.112h60.657v7.989h-60.657zM425.898 204.112h24.308v7.989h-24.308z"
        />
      </g>
    </svg>
  )
}

export default ContentComparison
